export default __webpack_public_path__ + "static/media/search_icon.c5c73c4a.svg";